import React, { Component } from "react";
import { compose } from "redux";
import { formValueSelector, Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import ApiCalendar from "react-google-calendar-api";
import * as Validate from "../../helpers/validations";
import Textfield from "../signup/components/Textfield";
import Button from "../../components/Button";
import SettingCalendar from "./components/SettingCalendar";
import { Row, Col } from "react-flexbox-grid";
import styles from "./styles/settings.module.scss";
import { ToastsContainer, ToastsStore } from "react-toasts";
import {
  getBadgeColor,
  putBadgeColor,
  putBadgeColorPromise,
  changeLiveliPassword,
  getSettingsCredentials,
  setSettings,
  setSettingsChanges
} from "../../actions/user-actions";
import { getTickers, putTicker } from "../../actions/tickers-actions";
import { interceptor } from "../../services/interceptor-service";
import cities from "./citiesUSA";
import timezones from "./timezonesUSA";
import "isomorphic-fetch";
import { Client } from "@microsoft/microsoft-graph-client";
import Autocomplete from "react-autocomplete-select";
import Dropdown from "../../components/Dropdown";
import ConfirmationModal from "../../components/ConfirmationModal";
import Tutorial from '../../components/Tutorial';

export class Settings extends Component {
  authOutlookData = {};
  constructor(props) {
    super(props);
    this.user = JSON.parse(localStorage.getItem("user"));
    this.state = {
      sign: ApiCalendar.sign,
      liveliColor:"",
      googleColor: "",
      outlookColor: "",
      typeCalendar: "",
      isOutlookAuthenticated: false,
      isGoogleAuthenticated: false,
      isCurrentPassword: false,
      isFirts: true,
      isLinkGoogle: true,
      isLinkOutlook: true,
      isCurrentPasswordVisible: false,
      isNewPasswordVisible: false,
      isPasswordConfirmationVisible: false,
      emailOutlook: localStorage.getItem("emailOutlook"),
      emailGoogle: localStorage.getItem("emailGoogle"),
      buttonSave: null,
      refresh: false,
      isTimeZone: false,
      unlinkOutlook: false,
      unlinkGoogle: false,
      isBadgeColor: false,
      isWeatherDefault: false,
      discardChanges: false,
      hasChange: false,
      weather: [],
      myTimeZone: this.props.userProfile.timeZone 
        ? this.props.userProfile.timeZone 
        : timezones[0],
      location: localStorage.getItem("location")
        ? localStorage.getItem("location")
        : "",
      myLocation: '',
      changeCurrentPassword: false,
      changePassword: false,
      changeConfirmPassword: false,
      isChangePassword: false,
      changeCalendarSetting: false
    };
    ApiCalendar.onLoad(() => {
      ApiCalendar.listenSign(this.signUpdate);
    });
  }

  signUpdate = () => {
    if (ApiCalendar.sign) {
      if (
        localStorage.getItem("emailGoogle") !== "null" &&
        localStorage.getItem("emailGoogle").indexOf("@") > -1
      ) {
        var data = {
          email: this.user.email,
          sortKey: this.user.sortKey,
          liveliColor: this.props.colorData.badgeColor.liveliColor !== null
            ? this.props.colorData.badgeColor.liveliColor
            : '#7200DA',
          googleColor: "default",
          outlookColor: this.state.outlookColor,
          emailGoogle: localStorage.getItem("emailGoogle"),
          emailOutlook: this.props.colorData.badgeColor.outlook,
          isTimeZone: false,
          isBadgeColor: true,
          isWeatherDefault: false
        };
        this.setState({isLinkGoogle: true})
        this.props.putBadgeColor(data);
      } else {
        setTimeout(() => {
          this.signUpdate();
        }, 200);
      }
    }
  };

  componentDidMount() {
    var data = {
      email: this.user.email,
      sortKey: this.user.sortKey
    };
    this.props.getBadgeColor(data);
    this.props.getTickers(data);
    this.props.getSettingsCredentials();
    localStorage.removeItem("refreshGoogle");
  }

  componentDidUpdate(prevProps) {
    if (this.props.getBadgeSuccess && !prevProps.getBadgeSuccess) {

      const { isLinkOutlook, isLinkGoogle, outlookColor, liveliColor, googleColor, hasChange, buttonSave, isFirts } = this.state;
      let liveli = '#7200DA';
      if (isLinkGoogle && isLinkOutlook && isFirts && this.props.colorData.badgeColor.liveliColor !== null ) 
        liveli = this.props.colorData.badgeColor.liveliColor
      if (!isLinkOutlook && !isLinkGoogle)
        liveli = this.props.colorData.badgeColor.liveliColor
      
        this.setState({
        hasChange: (isLinkGoogle || isLinkOutlook) && hasChange ? true : false,
        buttonSave: (isLinkGoogle || isLinkOutlook) && buttonSave !== null ? 'badgeColor' : null,
        emailOutlook: this.props.colorData.emailCalendar.outlook,
        emailGoogle: localStorage.getItem("emailGoogle"),
        outlookColor: isLinkOutlook ? this.props.colorData.badgeColor.outlook : outlookColor,
        googleColor: isLinkGoogle ?  this.props.colorData.badgeColor.google : googleColor,
        liveliColor: (isLinkGoogle && !isFirts) || (isLinkOutlook && !isFirts) 
          ? liveliColor 
          : liveli,
        isOutlookAuthenticated:
          this.props.colorData.emailCalendar.outlook &&
          this.props.colorData.emailCalendar.outlook.trim().length > 0 &&
          this.props.colorData.emailCalendar.outlook !== "null" &&
          this.props.colorData.badgeColor.outlook !== null ? true : false,
        isGoogleAuthenticated:
          this.props.colorData.emailCalendar.google &&
          this.props.colorData.emailCalendar.google.trim().length > 0 &&
          this.props.colorData.emailCalendar.google !== "null" && 
          this.props.colorData.badgeColor.google !== null ? true : false,
        isLinkGoogle: false,
        isLinkOutlook: false,
        isFirts: false,
        unlinkOutlook: false,
        unlinkGoogle: false
      });

      this.props.setSettingsChanges((isLinkGoogle || isLinkOutlook) && hasChange ? true : false)
    }

    if (this.props.putBadgeSuccess && !prevProps.putBadgeSuccess) {

      const { isLinkGoogle, isLinkOutlook, unlinkOutlook, unlinkGoogle }  = this.state;
      let text = 'Settings have been saved!'
      if ( isLinkGoogle ) text ='Google Calendar linked'
      if ( isLinkGoogle && unlinkGoogle) text = 'Google Calendar unlinked'
      if ( isLinkOutlook ) text = 'Outlook Calendar linked' 
      if ( isLinkOutlook && unlinkOutlook ) text = 'Outlook Calendar unlinked'

      this.actionToast(text);
      this.props.getBadgeColor({
        email: this.user.email,
        sortKey: this.user.sortKey
      });
    }

    if (this.props.passwordSuccess && !prevProps.passwordSuccess) {
      if (this.props.changePassData.success) {
        this.actionToast("Your password have been changed.");
      } else if ( this.props.changePassData.err.message === "Incorrect username or password.") {
        this.actionErrorToast("Incorrect password.");
      } else {
        this.actionErrorToast(this.props.changePassData.err.message);
      }
      this.setState({
        isChangePassword: false, 
        hasChange: false,
        changeConfirmPassword: false,
        changePassword: false,
        changeCurrentPassword: false,
      })
    }

    if (this.props.getTickresSuccess && !prevProps.getTickresSuccess) {
      const tikers = this.props.tickersData.tickersData;
      this.setState({
        weather: tikers.weather,
        location: tikers.weather[0] ? tikers.weather[0].name : "",
        myLocation: tikers.weather[0] ? tikers.weather[0].name : "",
      });
    }

    if (this.props.putTickerSuccess && !prevProps.putTickerSuccess) {
      this.props.getTickers({
        email: this.user.email,
        sortKey: this.user.sortKey
      });
    }

    if (this.props.getSettingsSuccess && !prevProps.getSettingsSuccess) {
      this.authOutlookData = this.props.credentialsData.apiOutlookconfig
      // this.authOutlookData = {
      //   "authEndpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?",
      //   "redirectUri": "https://localhost:3000/main/settings/",
      //   "appId": "8084ae22-07bf-46f3-9d1d-1d3453b9ff50", 
      //   "scopes": "openid profile User.Read Mail.Read Calendars.Read Contacts.Read"
      // }
    }
  }

  authGoogle = async () => {
    var data = {
      email: this.user.email,
      liveliColor: this.props.colorData.badgeColor.liveliColor !== null
        ? this.props.colorData.badgeColor.liveliColor
        : '#7200DA',
      sortKey: this.user.sortKey,
      googleColor: "default", //"default"
      outlookColor: this.props.colorData.badgeColor.outlook,
      emailOutlook: this.state.emailOutlook,
      isTimeZone: false,
      isBadgeColor: true,
      isWeatherDefault: false,
    };

    if (!this.state.isGoogleAuthenticated) {
      await ApiCalendar.handleAuthClick();
      this.saveDataGoogle();
    } else {
      ApiCalendar.handleSignoutClick();
      data.googleColor = null;
      data.emailGoogle = null;
      localStorage.setItem("showGoogle", "false");
      this.setState({isLinkGoogle: true, unlinkGoogle: true})
      this.props.putBadgeColor(data);
      setTimeout(() => {
        localStorage.setItem("emailGoogle", null);
      }, 2000);
    }
  };

  saveDataGoogle = () => {
    if (
      localStorage.getItem("emailGoogle") !== "null" &&
      localStorage.getItem("emailGoogle").indexOf("@") > -1
    ) {
      var data = {
        email: this.user.email,
        sortKey: this.user.sortKey,
        liveliColor: this.props.colorData.badgeColor.liveliColor !== null
          ? this.props.colorData.badgeColor.liveliColor
          : '#7200DA',
        googleColor: "default",
        outlookColor: this.props.colorData.badgeColor.outlook,
        emailGoogle: localStorage.getItem("emailGoogle"),
        emailOutlook: this.state.emailOutlook,
        isTimeZone: false,
        isBadgeColor: true,
        isWeatherDefault: false,
      };
      this.setState({isLinkGoogle: true})
      this.props.putBadgeColor(data);
    } else {
      setTimeout(() => {
        this.saveDataGoogle();
      }, 200);
    }
  };

  authOutlook = async () => {
    if (this.state.isOutlookAuthenticated) {
      var data = {
        email: this.user.email,
        sortKey: this.user.sortKey,
        outlookColor: null,
        emailOutlook: null,
        liveliColor: this.props.colorData.badgeColor.liveliColor !== null
          ? this.props.colorData.badgeColor.liveliColor
          : '#7200DA',
        googleColor: this.props.colorData.badgeColor.google,
        emailGoogle: this.state.emailGoogle,
        isTimeZone: false,
        isBadgeColor: true,
        isWeatherDefault: false,
      };
      this.setState({isLinkOutlook: true, unlinkOutlook: true})
      this.props.putBadgeColor(data);
      localStorage.removeItem("accessTokenOutlook");
      localStorage.removeItem("id_tokenOutlook");
      localStorage.setItem("showOutlook", "false");
    }
  };

  buildOutlookUrl = () => {
    if (!this.state.isOutlookAuthenticated) {
      // Generate random values for state
      sessionStorage.authState = Math.random()
        .toString(36)
        .substr(2, 9);
      sessionStorage.authNonce = Math.random()
        .toString(36)
        .substr(2, 9);

      var authParams = {
        response_type: "id_token token",
        client_id: this.authOutlookData.appId,
        redirect_uri: this.authOutlookData.redirectUri,
        scope: this.authOutlookData.scopes,
        state: sessionStorage.authState,
        nonce: sessionStorage.authNonce,
        response_mode: "fragment"
      };

      return (
        this.authOutlookData.authEndpoint +
        Object.entries(authParams)
          .map(e => e.join("="))
          .join("&")
      );
    } else {
      return;
    }
  };
  targetOutlook = () => {
    if (!this.state.isOutlookAuthenticated) return "_blank";
    else return "_self";
  };

  getOutlookTokens = async () => {
    //get the tokens from the url and store tgen on interceptor
    var params = new URLSearchParams(window.location.hash);

    if (params.has("#access_token")) {
      var token = params.get("#access_token");
      var id = params.get("id_token");
      interceptor.addValue("params", window.location.hash);
      interceptor.addValue("accessTokenOutlook", token);
      interceptor.addValue("id_tokenOutlook", id);

      this.getOutlookMail();
    }
  };

  loginOutlook = () => {
    localStorage.setItem("flagReload", "true");
    if (this.state.isOutlookAuthenticated) {
      var data = {
        email: this.user.email,
        sortKey: this.user.sortKey,
        liveliColor: this.props.colorData.badgeColor.liveliColor !== null
          ? this.props.colorData.badgeColor.liveliColor
          : '#7200DA',
        googleColor: this.props.colorData.badgeColor.google,
        outlookColor: null,
        emailOutlook: null,
        emailGoogle: this.state.emailGoogle,
        isTimeZone: false,
        isBadgeColor: true,
        isWeatherDefault: false,
      };
      this.setState({isLinkOutlook: true, unlinkOutlook: true})
      this.props.putBadgeColor(data);
      localStorage.removeItem("accessTokenOutlook");
      localStorage.removeItem("id_tokenOutlook");
      localStorage.setItem("showOutlook", "false");
    } else {
      var windowUrl = this.buildOutlookUrl();
      // eslint-disable-next-line no-unused-vars
      var loginWindow = window.open(windowUrl, "_blank");
      setTimeout(() => {
        this.checkForToken();
      }, 100);
    }
  };

  checkForToken = () => {
    var aToken = interceptor.getValue("accessTokenOutlook");
    if (aToken) {
      window.location.reload();
    } else {
      setTimeout(() => {
        this.checkForToken();
      }, 100);
    }
  };

  getOutlookMail = () => {
    var aToken = interceptor.getValue("accessTokenOutlook");
    if (aToken) {
      // Create a Graph client
      var client = Client.init({
        authProvider: done => {
          // Just return the token
          done(null, aToken);
        }
      });
      client.api("/me").get((err, res) => {
        if (err) {
          console.log(err);
        } else {
          localStorage.setItem("emailOutlook", res.userPrincipalName);
          this.sendOutlookData();
        }
      });
    } else {
      console.log("No outlook token available");
    }
  };

  sendOutlookData = () => {
    var data = {
      email: this.user.email,
      sortKey: this.user.sortKey,
      liveliColor: this.props.colorData.badgeColor.liveliColor !== null
        ? this.props.colorData.badgeColor.liveliColor
        : '#7200DA',
      outlookColor: "default", // FF585D
      emailOutlook: localStorage.getItem("emailOutlook"),
      googleColor: this.props.colorData.badgeColor.google,
      emailGoogle: this.state.emailGoogle,
      isTimeZone: false,
      isBadgeColor: true,
      isWeatherDefault: false,
    };
    localStorage.setItem("outlookColor", data.color);
    this.setState({isLinkOutlook: true})
    putBadgeColorPromise(data).then(() => {
      if (localStorage.getItem("flagReload") === "true") {
        window.opener.location.reload();
      }
      window.close();
    });
  };

  actionToast = message => {
    ToastsStore.success(message);
  };

  actionErrorToast = message => {
    ToastsStore.error(message);
  };

  saveSetting = () => {
    const { isChangePassword, hasChange, changeCalendarSetting } = this.state
    // for change Password
    if (isChangePassword) {
      let userData = {
        AccessToken: localStorage.getItem("accessToken"),
        // PreviousPassword: currentPassword,
        // ProposedPassword: password
        PreviousPassword: this.props.currentPassword,
        ProposedPassword: this.props.password
      };
      this.props.changeLiveliPassword(userData);
      this.setState({
        isCurrentPassword: false,
        isCurrentPasswordVisible: false,
        isNewPasswordVisible: false,
        isChangePassword: false
      });
      this.props.initialize({
        confirmPassword: null,
        currentPassword: null,
        password: null
      });
    }
    // For change in color, weather or location
    if (hasChange && changeCalendarSetting) {
      this.save()
    }
  };

  selectColor = (color, type) => {
    this.setState({
      isBadgeColor: true,
      changeCalendarSetting: true,
      hasChange: true,
    });
    this.initializateForm(true);
    this.props.setSettingsChanges(true)

    if (type === "Liveli") {
      this.setState({
        buttonSave: "badgeColor",
        liveliColor: color,
        typeCalendar: type
      });
    }
    if (type === "Google" && this.state.isGoogleAuthenticated) {
      this.setState({
        buttonSave: "badgeColor",
        googleColor: color,
        typeCalendar: type
      });
    }
    if (type === "Outlook" && this.state.isOutlookAuthenticated) {
      this.setState({
        buttonSave: "badgeColor",
        outlookColor: color,
        typeCalendar: type
      });
    }
  };

  viewCurrentPassword = () =>
    this.setState({
      isCurrentPasswordVisible: !this.state.isCurrentPasswordVisible
    });

  viewNewPassword = () =>
    this.setState({
      isNewPasswordVisible: !this.state.isNewPasswordVisible
    });

  viewConfirmPassword = () =>
    this.setState({
      isPasswordConfirmationVisible: !this.state.isPasswordConfirmationVisible
    });

  initializateForm = (hasChange) => {
    const { changeConfirmPassword, changePassword, changeCurrentPassword} = this.state;
    if (!changePassword && !changeCurrentPassword && !changeConfirmPassword) {
      this.props.initialize({
        confirmPassword: null,
        currentPassword: null,
        password: null
      });
      this.setState({isChangePassword: false, hasChange})
    } else {
      this.setState({isChangePassword: true})
    }
  }

  onChangeEventAttributeCurrentPassword = (e) => {
    const changeCurrentPassword = e.target.value ? true : false
    this.setState({ 
      changeCurrentPassword, 
      hasChange: true
    }, () => this.initializateForm(false))
  }

  onChangeEventAttributePassword = (e) => {
    const changePassword = e.target.value ? true : false
    this.setState({ 
      changePassword,
      hasChange: true 
    }, () => this.initializateForm(false))
  }

  onChangeEventAttributeConfirmPassword = (e) => {
    const changeConfirmPassword = e.target.value ? true : false
    this.setState({ 
      changeConfirmPassword,
      hasChange: true
    }, () => this.initializateForm(false))
  }

  save = () => {
    var data = {
      email: this.user.email,
      sortKey: this.user.sortKey,
      liveliColor: this.state.liveliColor,
      googleColor: this.state.googleColor,
      outlookColor: this.state.outlookColor,
      emailOutlook: this.state.emailOutlook,
      emailGoogle: this.state.emailGoogle,
      isTimeZone: this.state.isTimeZone,
      isBadgeColor: this.state.isBadgeColor,
      isWeatherDefault: this.state.isWeatherDefault,
      timeZone: this.state.myTimeZone,
      weatherTicker: this.state.weather
    };
    this.setState({
      isLinkGoogle: false, 
      isLinkOutlook: false, 
      isChangePassword: false,
      changePassword: false,
      changeCurrentPassword: false,
      changeConfirmPassword: false,
    })
    this.props.putBadgeColor(data);
    this.props.setSettings(this.state.weather, this.state.myTimeZone);
    if (this.state.typeCalendar === "Outlook")
      localStorage.setItem("outlookColor", this.state.outlookColor);
  };

  setTimeZone = (timezone) => {
    this.setState({
      changeCalendarSetting: true,
      myTimeZone: timezone, 
      isTimeZone: true,
      hasChange: true,
    });
    this.initializateForm(true);
    this.props.setSettingsChanges(true)
    localStorage.setItem("timezone", timezone);
  };

  resetVariables = () => {
    this.setState({
      changeCalendarSetting: false,
      isCurrentPassword: false,
      isCurrentPasswordVisible: false,
      isNewPasswordVisible: false,
      buttonSave: null,
      googleColor: this.props.colorData.badgeColor.google,
      outlookColor: this.props.colorData.badgeColor.outlook,
      isTimeZone: false,
      isWeatherDefault: false,
      isBadgeColor: false,
      hasChange: false,
      discardChanges: false,
      liveliColor: this.props.colorData.badgeColor.liveliColor !== null
          ? this.props.colorData.badgeColor.liveliColor
          : '#7200DA',
      myTimeZone: this.props.userProfile.timeZone 
        ? this.props.userProfile.timeZone 
        : timezones[0],
      location: this.state.myLocation
    });
    this.props.initialize({
      confirmPassword: null,
      currentPassword: null,
      password: null
    });
    this.props.setSettingsChanges(false)
  };

  setLocation = location => {
    let tickers = this.state.weather;
    var index = tickers.map(function(e) { return e.name; }).indexOf(location);
    if (index > -1) tickers.splice(index, 1);

    let newLocation = {
      name: location,
      active: true,
      id: location
    };
    tickers[0] = newLocation;
    this.initializateForm(true);
    this.setState({
      location: location,
      weather: tickers,
      hasChange: true,
      changeCalendarSetting: true,
      isWeatherDefault: true,
    })

    this.props.setSettingsChanges(true)
    localStorage.setItem("location", location);
  };

  closeDiscardChangesModal = () => {
    this.setState({
      discardChanges: false
    })
  }

  discardChanges = () => {
    this.resetVariables()
  }

  discardChangesModal = () => {
    return (
      <ConfirmationModal
        title="Discard Changes"
        label="Are you sure you want to discard these changes?"
        confirmText="Accept"
        cancelText="Cancel"
        onClose={this.closeDiscardChangesModal}
        onConfirm={this.discardChanges}
      />
    )
  }

  inputOnChange =  (e) => {
    this.setState({
      location: e.target.value,
      isWeatherDefault: false,
      hasChange: false,
      buttonSave: null
    })
    this.props.setSettingsChanges(true)
  }

  disableButton = () => {
    const { invalid } = this.props
    const { isChangePassword, hasChange } = this.state
    let value = true
    if (hasChange && !isChangePassword) {
      value = false
    }
    if (isChangePassword && !invalid ){
      value = false
    }
    return value
  }

  render() {
    ApiCalendar.handleAuthClick = function() {
      if (this.gapi) {
        this.gapi.auth2
          .getAuthInstance()
          .signIn()
          .then(
            res => {
              const basicProfile = res.getBasicProfile();
              var email = basicProfile.getEmail();
              localStorage.setItem("emailGoogle", email);
            },
            err => console.log("err", err)
          );
      } else {
        console.log("Error: this.gapi not loaded");
      }
    };

    this.getOutlookTokens();
    //this.getOutlookMail();
    const { isCurrentPasswordVisible, isNewPasswordVisible, isPasswordConfirmationVisible } = this.state;
    
    return (
      <div className={styles.__container}>
        <Tutorial 
          stepsEnabled={true}
          type={'settings'}
          />
        <section className={styles.__containerForm}>
          <ToastsContainer store={ToastsStore} />
          {this.state.discardChanges && this.discardChangesModal()}
          <Row className={styles.__container_settings}>
            <Col xs={12} className={styles.__title}>
              Settings
            </Col>
            <Col xs={12} className={styles.__settings_canvas}>
              <Row center="xs" className={styles.__panel}>
                <Col xs={4} className={styles.__user}>
                  <div className={styles.__border_user}>
                    <Row center="xs">
                      <div
                        className={styles.__subtitle}
                        style={{ paddingBottom: 5 }}
                      >
                        User Information
                      </div>
                    </Row>
                    <div
                      style={{
                        paddingTop: this.user.sortKey === "liveli" ? 0 : "2rem"
                      }}
                    >
                      <div className={styles.__profile_img}>
                        <img
                          className={styles.__img}
                          src={"/images/defaultProfile.jpg"}
                          alt="Liveli Logo"
                        />
                      </div>
                      <div className={styles.__txt_information}>Name</div>
                      <div>{this.user.name}</div>
                      <div className={styles.__txt_information}>
                        Email Address
                      </div>
                      <div>{this.user.email}</div>
                      {this.user.sortKey !== "liveli" && (
                        <div>
                          <div className={styles.__txt_information}>Sesion</div>
                          <div>
                            {this.user.sortKey.charAt(0).toUpperCase() +
                              this.user.sortKey.slice(1)}
                          </div>
                        </div>
                      )}
                    </div>
                    {this.user.sortKey === "liveli" && (
                      <div>
                        <Row style={{ paddingLeft: 9, paddingRight: 9 }}>
                          {" "}
                          <hr className={styles.__line} />
                        </Row>
                        <div
                          className={styles.__subtitle}
                          style={{ paddingTop: 5 }}
                        >
                          Change Password
                        </div>

                        <div className={styles.__form}>
                          <Field
                            style={{paddingBottom: 5}}
                            name="currentPassword"
                            onChange={this.onChangeEventAttributeCurrentPassword}
                            props={{
                              viewPassword: true,
                              input_type: isCurrentPasswordVisible
                                ? "text"
                                : "password",
                              label: "Current Password",
                              viewPassword_press: this.viewCurrentPassword,
                              viewPassword_icon: isCurrentPasswordVisible
                                ? "eyeoff"
                                : "eye",
                              showTooltip: true,
                              id: "currentPassword",
                              isSetting: true,
                              loginView: true
                            }}
                            component={Textfield}
                            validate={[
                              Validate.minLength8,
                              Validate.maxLength16,
                              Validate.password
                            ]}
                          />
                          <Field
                            style={{paddingBottom: 5}}
                            name="password"
                            onChange={this.onChangeEventAttributePassword}
                            props={{
                              viewPassword: true,
                              input_type: isNewPasswordVisible
                                ? "text"
                                : "password",
                              label: "New Password",
                              viewPassword_press: this.viewNewPassword,
                              viewPassword_icon: isNewPasswordVisible
                                ? "eyeoff"
                                : "eye",
                              showTooltip: true,
                              id: "password",
                              isSetting: true,
                              loginView: true
                            }}
                            component={Textfield}
                            validate={[
                              Validate.minLength8,
                              Validate.maxLength16,
                              Validate.password
                            ]}
                          />
                          <Field
                            name="confirmPassword"
                            onChange={this.onChangeEventAttributeConfirmPassword}
                            props={{
                              viewPassword: true,
                              input_type: isPasswordConfirmationVisible
                                ? "text"
                                : "password",
                              label: "Confirm New Password",
                              viewPassword_press: this.viewConfirmPassword,
                              showTooltip: true,
                              id: "confirmPassword",
                              isSetting: true,
                              viewPassword_icon: isPasswordConfirmationVisible
                                ? "eyeoff"
                                : "eye",
                              loginView: true
                            }}
                            component={Textfield}
                            validate={[
                              Validate.passwordMatch
                            ]}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </Col>
                <Col xs={8} className={styles.__calendar_data}>
                  <div className={styles.__border}>
                    <Row className={styles.__calendar_st}>
                      <Col xs={12}>
                        <div className={styles.__subtitle}>
                          Calendar Settings
                        </div>
                      </Col>
                      {/* Improving calendar settings */}
                      <section
                        className={[styles.__calendar__cus, 'step2-settingPage'].join(' ')}
                        style={{ height: "calc(100% - 56px)" }}
                      >
                          <SettingCalendar
                            type={"Liveli"}
                            color={this.state.liveliColor}
                            onClickColor={this.selectColor}
                            connect
                            email={this.user.email}
                          />
                          <SettingCalendar
                            type={"Google"}
                            color={this.state.googleColor}
                            onClickConnect={this.authGoogle}
                            onClickColor={this.selectColor}
                            connect={this.state.isGoogleAuthenticated}
                            email={this.props.colorData.emailCalendar.google}
                          />
                          <SettingCalendar
                            type={"Outlook"}
                            onClickConnect={this.loginOutlook}
                            connect={this.state.isOutlookAuthenticated}
                            color={this.state.outlookColor}
                            onClickColor={this.selectColor}
                            email={this.props.colorData.emailCalendar.outlook}
                          />
                      </section>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Row>
                          <Col xs={6} className="step3-settingPage">
                            <div
                              className={styles.__border__no_ov}
                              style={{ height: 154 }}
                            >
                              <Row>
                                <Col xs={12}>
                                  <div className={styles.__subtitle}>
                                    Weather Default Location
                                  </div>
                                </Col>
                              </Row>
                              <div className={styles.__timezone_container}>
                                <Autocomplete
                                  defaultInputValue={this.state.location}
                                  placeholder={"Location"}
                                  maxOptionsLimit={4}
                                  inputJSX = { (props)=>
                                    <input {...props} 
                                      value={this.state.location} onChange={(e) => this.inputOnChange(e)}
                                      />
                                  }
                                  getItemValue={item => {
                                    return item.city + ", " + item.state;
                                  }}
                                  onSelect={selectedValue => {
                                    this.setLocation(selectedValue);
                                  }}
                                  itemsData={cities}
                                  globalStyle="
                                              input {
                                                  background-color: white;
                                                  padding: 10px;
                                                  font-size: 16px;
                                                  border: #d9d9d9 1px solid;
                                                  border-radius: 4px;
                                                  font-family: Montserrat;
                                                  color: #000;
                                                  font-size: 0.875rem;
                                                  font-weight: inherit;
                                                  height: 40px;
                                                  outline: 0;
                                              }

                                              .autocomplete {
                                                  width: 100%;
                                              }

                                              .___optionsDiv___ {
                                                  border-bottom: 0.5 solid #d4d4d4;
                                                  border-top: 1px solid #d4d4d4;
                                                  text-align: left;
                                                  font-family: Montserrat;
                                                  font-size: 12px;
                                                  top: auto;
                                                  z-index: 99;
                                                  bottom: 100%;
                                                  background: white;
                                                  box-shadow: 3px 10px 20px rgba(33, 33, 33, 0.1);
                                              }

                                              .___optionsDiv___ div {
                                                  padding: 5px;
                                                  border-bottom: 0 solid #d4d4d4;
                                              }
                                              "
                                />
                              </div>
                            </div>
                          </Col>
                          <Col xs={6} className="step4-settingPage">
                            <div
                              className={styles.__border__no_ov}
                              style={{ height: 154 }}
                            >
                              <Row>
                                <Col xs={12}>
                                  <div className={styles.__subtitle}>
                                    Time Zone Setting
                                  </div>
                                </Col>
                              </Row>
                              <div className={styles.__timezone_container}>
                                <Dropdown
                                  placeholder={"Hola"}
                                  dropdownKey={this.state.dropdownKey}
                                  label=""
                                  options={timezones}
                                  onChange={this.setTimeZone}
                                  defaultValue={this.state.myTimeZone}
                                  value={this.state.myTimeZone}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <div className={styles.__btn_save}>
              <Button
                type="button"
                cancel={true}
                disabled={!this.state.hasChange}
                label="Cancel"
                click={ () => this.setState({discardChanges: true})}
              />
              <Button 
                type="button"
                disabled={this.disableButton()}
                login 
                label="Save" 
                style= {{marginLeft: '12px'}} 
                click={ () => this.saveSetting()}
              />
          </div>
        </section>
      </div>
    )
  }

}

const form = reduxForm({
  form: "changePassword"
});

const mapStateToProps = state => {
  const selector = formValueSelector("changePassword");
  return {
    userProfile: state.userReducer.userProfile,
    currentPassword: selector(state, "currentPassword"),
    password: selector(state, "password"),
    confirmPassword: selector(state, "confirmPassword"),
    getBadgeSuccess: state.userReducer.getBadgeSuccess,
    putBadgeSuccess: state.userReducer.putBadgeSuccess,
    colorData: state.userReducer.colorData,
    credentialsData: state.userReducer.credentialsData,
    passwordSuccess: state.userReducer.passwordSuccess,
    changePassData: state.userReducer.changePassData,
    loading: state.tickersReducer.loading,
    putTickerSuccess: state.tickersReducer.putTickerSuccess,
    getTickresSuccess: state.tickersReducer.getTickresSuccess,
    getSettingsSuccess: state.userReducer.getSettingsSuccess,
    tickersData: state.tickersReducer.tickersData,
    hasChangesSettings: state.userReducer.hasChangesSettings,
    stepTutorial: state.userReducer.stepTutorial
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getBadgeColor: userData => dispatch(getBadgeColor(userData)),
    putBadgeColor: userData => dispatch(putBadgeColor(userData)),
    getSettingsCredentials: () => dispatch(getSettingsCredentials()),
    changeLiveliPassword: userData => dispatch(changeLiveliPassword(userData)),
    getTickers: userData => dispatch(getTickers(userData)),
    putTicker: userData => dispatch(putTicker(userData)),
    setSettings: (weather, location) => dispatch(setSettings(weather, location)),
    setSettingsChanges: hasChanges => dispatch(setSettingsChanges(hasChanges))
  };
};

export default compose(
  form,
  connect(mapStateToProps, mapDispatchToProps)
)(Settings);
